import { Attribute } from "../../types/prodcatBaseTypes";
import { StandardProps } from "../componentMap";
import { ChannelBannerUI } from "./ChannelBannerUI";
import { DiorBackStageBannerUI } from "./DiorBackstageBannerUI";
import { DiorBannerUI } from "./DiorBannerUI";

export function BrandBanner({ product }: Pick<StandardProps, "product">) {
  const { brand, attributes } = product;

  if (brand && brand.name && brand.name.toUpperCase() === "CHANEL") {
    return <ChannelBannerUI />;
  }

  if (brand && brand.name && brand.name.toUpperCase() == "DIOR") {
    return <DiorBannerUI />;
  }

  return null;
}

function isDiorBackStage(attributes: Array<Attribute>) {
  const subbrand = attributes.find(
    (attr) => attr.key == "subbrand" && attr.values?.includes("Dior Backstage"),
  );
  const beautyrange = attributes.find(
    (attr) =>
      attr.key == "corebeautyrange" && attr.values?.includes("Dior Backstage"),
  );
  return Boolean(subbrand || beautyrange);
}
